import { HaloType } from 'search/ListingCard/ListingCard.types';

export function getHaloType(
    isPremium: boolean,
    showHalo: boolean,
    presentationType?: string
): HaloType {
    if (!showHalo) {
        return HaloType.NONE;
    }
    if (isPremium) {
        return HaloType.PREMIUM;
    }
    if (presentationType === 'FEATURED') {
        return HaloType.FEATURED;
    }
    return HaloType.NONE;
}
